// import {lazy} from 'react'
import Home from '@pages/home'
import CockpitHome from '@pages/cockpit-home'
import CockpitOverview from '@pages/cockpit-home/cockpit-overview'
import CockpitIndex from '@pages/cockpit-home/cockpit-index'
import CockpitLightControl from '@pages/cockpit-home/cockpit-light-control'
import CockpitEnergyStatistics from '@pages/cockpit-home/cockpit-energy-statistics'
import RealtimeMonitor from '@pages/cockpit-home/cockpit-realtime-monitor'
import Login from '@pages/login'

const routes = [
  // {
  //   path: '/home',
  //   component: CockpitHome,
  //   // routes: accountRoutes,
  // },
  {
    path: '/cockpit',
    component: CockpitHome,
    routes: [
      {
        name: '驾驶舱概览',
        path: '/cockpit/overview',
        component: CockpitOverview,
      },
      {
        name: '驾驶舱首页',
        path: '/cockpit/index',
        component: CockpitIndex,
      },
      {
        name: '灯光控制',
        path: '/cockpit/lightControl',
        component: CockpitLightControl,
      },
      {
        name: '能耗统计',
        path: '/cockpit/energyStatistics',
        component: CockpitEnergyStatistics,
      },
      {
        name: '能耗统计',
        path: '/cockpit/realtimeMonitor',
        component: RealtimeMonitor,
      },
    ],
  },
  {
    name: '驾驶舱概览',
    path: '/overview',
    component: CockpitOverview,
  },
  {
    path: '/home',
    component: Home,
  },
  {
    path: '/login',
    component: Login,
  },
]

export default routes